import { ViewEditor } from "pytha";


export abstract class BaseCommand {

    type = 'BaseCommand';
    uuid: string;
    editor: ViewEditor;

    setValue(key: string, value: any) {
        this[key] = value;
    }

    getValue(key: string) {
        return this[key];
    }

    abstract execute(): void;
    abstract undo(): void;

    onExecuteCallback: () => void
    onUndoCallback: () => void
}